import React from 'react';
import { useState, useRef } from 'react';
import { Box, Button, FormControl, InputLabel, TextField, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/Project_Images/App_logo.png';
import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ApiSendOtp, ApiVerifyOtp } from '../../apiService/Core/Apicall.tsx';
import { useDispatch, useSelector } from 'react-redux';
import { hideLoading, showLoading } from '../../Redux/loadingSlice.tsx';
import Loading from '../Loader/Loading.tsx';
import { toast } from 'react-toastify';

const Otp: React.FC = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const inputRef = useRef<any>([]);
    const [showerror, setshowerror] = useState<boolean>(false);
    const isForgot = location?.state?.isForgot
    const navigation = useNavigate()
    const loading = useSelector((state: any) => state.loader.isLoading);

    const [otp, setOtp] = useState(Array(6).fill(""));

    // Formik Setup
    const formik = useFormik({
        initialValues: {
            otp0: '',
            otp1: '',
            otp2: '',
            otp3: '',
            otp4: '',
            otp5: '',
        },
        validationSchema: Yup.object({
            otp0: Yup.string().matches(/^[0-9]$/, "Must be a single digit").required("Required"),
            otp1: Yup.string().matches(/^[0-9]$/, "Must be a single digit").required("Required"),
            otp2: Yup.string().matches(/^[0-9]$/, "Must be a single digit").required("Required"),
            otp3: Yup.string().matches(/^[0-9]$/, "Must be a single digit").required("Required"),
            otp4: Yup.string().matches(/^[0-9]$/, "Must be a single digit").required("Required"),
            otp5: Yup.string().matches(/^[0-9]$/, "Must be a single digit").required("Required"),
        }),
        validateOnChange: true,
        validateOnBlur: false,
        onSubmit: async (values) => {
            const userData = JSON.parse(localStorage.getItem('userData') || '{}');
            const Apidata = {
                emailId: localStorage.getItem('emailId'),
                requestType: isForgot ? "forgot_password" : "new_shopper_registration",
                otp: Number(`${Object.values(values).join('')}`)

            }
            try {
                const response: any = await ApiVerifyOtp(Apidata);
                if (response.status) {
                    localStorage.setItem('auth', "setpassword");
                    // console.log(response.message)
                    navigation('/setpassword', isForgot && { state: { isForgot: true } })
                }
            }
            catch (error) {
                const message =
                    error?.response?.data?.message || // API error message
                    error?.message ||                 // JS error message
                    String(error);
                toast.error(message)
                navigation('/otp')
            }
        }
    });

    const handleChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        let value = event.target.value;
        if (!/^[0-9]?$/.test(value)) return; // Allow only numbers

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Move to next input field if a number is entered
        if (value && index < 5) {
            inputRef.current[index + 1].focus();
        }
        formik.setFieldValue(`otp${index}`, value);
    };

    const clearInput = (index: number, event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Backspace') {
            const newOtp = [...otp];
            newOtp[index] = '';
            setOtp(newOtp);
            formik.setFieldValue(`otp${index}`, '');

            if (index > 0) {
                inputRef.current[index - 1].focus();
            }
        }
    };
    const resendotp = async () => {
        const Apidata = {
            emailId: localStorage.getItem('emailId'),
            requestType: "new_shopper_registration"
        }
        const response = await ApiSendOtp(Apidata)
        toast.success(response.message)
    }
    return (
        <Box className='p-50-120 d-flex flex-column' height={{ xs: "80vh", sm: '100vh' }}>
            <Box component='img' className='col-md-4 col-6 mb-md-5 mb-3' src={logo} alt="" />
            <Box className='flex-grow-1 mt-5' position='relative'>
                <Typography className='text-main fs-3 fw-bold'>{isForgot ? "Verify Your Email" :"OTP"}</Typography>
                <Typography className='fs-18 '>{isForgot?"Please enter the OTP sent to your registered email address to continue and set your new password.":"Check your email and enter the OTP to complete email verification."}</Typography>
                <Box>
                    <form onSubmit={formik.handleSubmit}>
                        <FormControl className='col-12 mt-5'>
                            <InputLabel>
                                <span>OTP{" "}
                                    <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                </span>
                            </InputLabel>
                            <Box display="flex" gap={1} justifyContent="center">
                                {otp.map((digit, index) => (
                                    <Box key={index} display="flex" flexDirection="column" alignItems="center">
                                        <TextField
                                            id={`otp-${index}`}
                                            value={formik.values[`otp${index}`]}
                                            onChange={(e: any) => handleChange(index, e)}
                                            onKeyDown={(e: any) => clearInput(index, e)}
                                            inputRef={(el) => (inputRef.current[index] = el)}
                                            variant="outlined"
                                            className='otp'
                                            inputProps={{
                                                maxLength: 1,
                                                style: { textAlign: 'center', fontSize: '1.5rem', padding: '14px' }
                                            }}

                                        />
                                        {showerror && formik.errors[`otp${index}`] ? (
                                            <Typography className="error ">
                                                {formik.errors[`otp${index}`]}
                                            </Typography>
                                        ) : null}

                                    </Box>
                                ))}
                            </Box>
                        </FormControl>
                        <Link to='' className='text-main text-end d-block mt-2' onClick={resendotp}>Resend OTP?</Link>

                        <Button type="submit" onClick={() => setshowerror(true)} fullWidth className='button-primary mt-4'>{isForgot ? 'Verify OTP' : 'Next'}</Button>
                    </form>

                </Box>
            </Box>
            {loading && <Loading />}
        </Box>
    );
};

export default Otp;